import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

import { timezoneStore } from './timezones';

const normalizeDate = (input: string) => {
  const trimmedInput = input.trim();

  // Keep explicit timezone offsets untouched
  if (/[+-]\d{2}:\d{2}$/.test(trimmedInput)) {
    return trimmedInput.replace(/\.(\d{3})\d*/, '.$1').replace(/\s+/, 'T');
  }

  // Keep UTC timestamps untouched
  if (trimmedInput.endsWith('Z')) {
    return trimmedInput.replace(/\.(\d{3})\d*/, '.$1').replace(/\s+/, 'T');
  }

  const timezoneAbbrevMatch = trimmedInput.match(
    /^(.*\d{2}:\d{2}(?::\d{2})?)\s+[A-Za-z]{2,4}$/
  );
  if (timezoneAbbrevMatch) {
    const dateTime = timezoneAbbrevMatch[1];
    return dateTime.replace(/\s+/, 'T');
  }

  // No timezone → treat as LOCAL time
  return trimmedInput.replace(/\.(\d{3})\d*/, '.$1').replace(/\s+/, 'T');
};

export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy HH:mm';

export const formatDate = (
  date?: string | null,
  timezone?: string,
  dateFormat = DEFAULT_DATE_FORMAT
) => {
  if (!date) return '';
  if (typeof date !== 'string') return String(date);

  const normalizedDate = normalizeDate(date);
  const parsedDate = new Date(normalizedDate);

  if (isNaN(parsedDate.getTime())) return 'Invalid Date';

  if (timezone) {
    return formatInTimeZone(parsedDate, timezone, dateFormat);
  }

  return format(parsedDate, dateFormat);
};

export const formatDateWithAppTimezone = (
  date?: string | null,
  dateFormat = DEFAULT_DATE_FORMAT
) => {
  const currentTimezone = timezoneStore.getSnapshot().currentTimezone;
  return formatDate(date, currentTimezone, dateFormat);
};
